import { useInfoBlockData } from "Pages/BusinessLogistics/Analytics/Page/@hooks"
import { REQUEST_TYPE } from "Pages/BusinessLogistics/Analytics/Page/@constants"
import React from "react"
import { AppAnalyticsCard } from "@components"

export default function EuropcarMonthSearchesCard() {

	const { res, isLoading } = useInfoBlockData(REQUEST_TYPE.MONTH, true)

	const { searches } = res

	return <AppAnalyticsCard isLoading={isLoading} countUp={searches} label="This month" icon={"calendar-days"} iconColor={"colors.red"}/>

}